import React from 'react';
import {Container, Row, Col} from "react-bootstrap";
import funfacts from '../../data/funfact/funfact-one.json'
import FunfactItem from "components/funfact/FunFactItemOne";

const FunFactOne = () => {
    return (
        <div className="bk-number-speaks section-ptb-xl bg_color--black">
            <Container>
                <Row>
                    <Col lg={7}>
                        <div className="number-speaks">
                            <div className="content">
                            {/* <div className="content wow move-up"> */}
                                <h3 className="creative-color">Nuestra experiencia</h3>
                                <h2 className='white'>Años facilitando el acceso<br/> al universo tecnológico</h2>
                                {/* <a className="bk-btn theme-btn" href={process.env.PUBLIC_URI + '/team'}>Conoce al equipo</a> */}
                            </div>
                        </div>
                    </Col>

                    <Col lg={5} className="mt_md--40 mt_sm--40">
                        <div className="speakers-number-wrap mt--n70">
                            {funfacts.map(funfact => (
                                <FunfactItem
                                    key={funfact.id}
                                    number={funfact.numbers}
                                    title={funfact.title}
                                    content={funfact.content}
                                />
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default FunFactOne;
